import React, { lazy, Suspense } from 'react'
import { Route } from 'react-router-dom'
import Nixi1Loading from '../../../components/Nixi1Loading'

const Bookings = lazy(() => import('../../../components/Bookings'))
// const  = lazy(() => import('../../../views/Dashboard/Bookings/DetailedBooking'))
const BookingDetails = lazy(() => import('../../../components/Bookings/BookingDetails'))
// const BookingEdit = lazy(() => import('../../../views/Dashboard/Bookings/BookingEdit'))
const InsuranceDetails = lazy(() => import('../../../components/Bookings/InsuranceDetails'))

// eslint-disable-next-line react/display-name
export default ({ match }) => (
  <Suspense fallback={<Nixi1Loading />}>
    {/* Edit Booking */}
    {/* <Route path={`${match.path}/:id/edit`} render={props => <BookingEdit {...props} />} /> */}

    {/* List all Bookings */}
    <Route path={match.path} render={(props) => <Bookings {...props} />} />
    <Route exact path={`${match.path}/:id`} render={(props) => <BookingDetails {...props} />} />
    <Route exact path={`${match.path}/insurance/:id`} render={(props) => <InsuranceDetails {...props} />} />
  </Suspense>
)
